import type { CoachingArtifact } from "../../hooks/useCoachingArtifacts";
import type { ArtifactsActions } from "../coachingGeneratorStore";

export const createArtifactsActions = (set: any): ArtifactsActions => ({
  setExistingArtifacts: (artifacts: CoachingArtifact[]) => {
    set({ existingArtifacts: artifacts });
  }
});
